export default __webpack_public_path__ + "static/media/lvodka.1988b090.jpg";